// extracted by mini-css-extract-plugin
export default {"blueHeader":"blueHeader-oiRP1","title":"title-rCB8r"};